import { Banner } from "@shopify/polaris";
import React from "react";

interface ValidationErrorBannerProps {
    message: string;
    show: boolean;
}

const ValidationErrorBanner: React.FC<ValidationErrorBannerProps> = ({ message, show }) => {
    if (!show) return null;

    return (
        <Banner title={message} status="critical"> </Banner>
    );
};

export default ValidationErrorBanner;
